export default {
    title: 'Seed Letter',
    intro: `By looking at 'letters' and 'words that use those letters,' you can learn how words <br>are made and the principles behind them. With Seed Letter <br>training, you can easily infer the meaning of unknown words.`,
    quizIntro: "Try solving the problems while recalling the letters you've learned.",
    header: {
        navigator: 'Level {level} Round {round}',
    },
    subject: {
        letter: 'Learn Seed Letters',
        relation: 'Check Semantic Relationships',
        board: "Seed Letters I've Learned",
        lesson: 'Seed Letter Training',
        quiz: 'Seed Letter Test',
    },
    indicator: {
        letter: 'Click on the letters to learn the shape, sound, and meaning of the Seed Letter.',
        word: 'Click on a word to learn how the Seed Letter is used in the word.',
        words: 'Learn two words that contain a Seed Letter.',
        choose1: 'The two "word" below have a letter in common. <br/>',
        choose2: "Which of the two words uses the 'word' letter?",
        relation: 'What is the semantic relationship between the two Seed Letters?',
        quiz: 'Which letter is the correct one to fill in the blank?',
    },
    study: {
        example: 'Example Sentence',
        meaning: 'Meaning',
        sound: 'Sound',
        listen: 'Listen',
    },
    modal: {
        notCompleted: 'You can learn this after completing all of the previous lessons.',
        moveToWaiting: 'Would you like to go to the Waiting Room?',
        invalidAccess: 'Invalid access.',
    },
    exitModal: {
        title: 'Training is not finished yet!',
        message: 'If you stop now, your training progress may not be saved!',
        continue: 'Continue',
        stop: 'Stop',
    },
    result: {
        totalQuestionMessage: 'You got score out of total questions correct.',
        checkMessage: 'Check all the correct answers carefully.',
        correct: 'Correct',
        selected: 'Selected',
        incorrect: 'Incorrect',
    },
    button: {
        nextWord: 'Next Lesson',
        nextLevel: 'Go to Next Level',
        start: 'Start',
        finishStudy: 'Finish Study',
        finishExam: 'Finish Exam',
        confirm: 'Confirm',
    },
    relation: {
        synonym: {
            name: 'Synonym',
            description: 'The two letters look different  but have similar meanings',
        },
        opposite: {
            name: 'Antonym',
            description: 'The two letters have opposite meanings',
        },
        hierarchy: {
            name: 'Hierarchy',
            description: 'The meaning of one letter includes the meaning of the other',
        },
        same: {
            name: 'Homophone',
            description: 'The two letters sound the same but have different meanings',
        },
        different: {
            name: 'Polysemy',
            description: 'One letter has multiple meanings',
        },
    },
};
